<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';

  .mainNaviBar{
    background-color: color("nile");
    width: 100%;
    max-width: 150px;
    min-width: 100px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .secondaryNavi{
    height: 50px;
    display: flex;
    justify-content: center;
    align-items:center;
    background-color: rgba(#ffffff, 0.1);

    &__link{
      width: 20px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      svg {
        fill: color("nile", "dark");
        transition: all 0.2s ease-out;
      }
      &:hover{
        svg {
          fill: color("white");
        }
      }
    }
  }
  .logout{
    display: flex;
    justify-content: center;
    align-items:center;
    background-color: rgba(#ffffff, 0.1);
    transition: all 0.2s ease-out;
    svg{
      @include svg-dim("medium");
    }
    &:hover{
      background-color: color("warning");
      svg {
        fill: color("white");
      }
    }
  }

  .primaryNavi{
    display: flex;
    justify-content: center;
    align-items:center;
    flex-grow: 1;
    flex-direction: column;

    svg {
      fill: color("nile", "dark");
      transition: all 0.2s ease-out;
    }

    &__link{
      color: white;
      width: 40px;
      height: 40px;
      text-decoration: none;

      &:hover{
        svg {
          fill: color("white");
        }
        .primaryNavi__icon-label{
          color: color("white");
          opacity: 1;
        }
      }
    }

    &__icon-label{
      transition: all 0.2s ease-out;
      color: color("nile", "dark");
      font-size: 12px;
      display: block;
      margin-top: 0.3em;
      text-align: center;
      opacity: 0.5;
    }

    &__item + &__item{
      margin-top: 8px;
    }
  }
</style>
<template>
  <nav class="mainNaviBar">
    <div>
      <div class="secondaryNavi">
        <v-button class="secondaryNavi__link --blank" @click.prevent="settings">
          <svg>
            <use xlink:href="#settings"></use>
          </svg>
        </v-button>
        <a href="" class="secondaryNavi__link">
          <svg>
            <use xlink:href="#user"></use>
          </svg>
        </a>
      </div>
    </div>
    <div class="mainNaviBar__primaryNavi primaryNavi">
      <div class="primaryNavi__item">
        <router-link :class="'primaryNavi__link'" :to="{ path: '/album', params: { id: 1 } }">
          <svg>
            <use xlink:href="#album"></use>
          </svg>
          <span class="primaryNavi__icon-label">Album</span>
        </router-link>
        <!-- <a href="" class="primaryNavi__link">
          <svg>
            <use xlink:href="#album"></use>
          </svg>
          <span class="primaryNavi__icon-label">Album</span>
        </a> -->
      </div>
      <div class="primaryNavi__item">
        <router-link :class="'primaryNavi__link'" :to="{ path: '/favourites' }">
          <svg>
            <use xlink:href="#favourite"></use>
          </svg>
          <span class="primaryNavi__icon-label">Favourite</span>
        </router-link>
      </div>
<!--       <div class="primaryNavi__item">
        <router-link :class="'primaryNavi__link'" :to="{ path: '/search' }">
          <svg>
            <use xlink:href="#search"></use>
          </svg>
          <span class="primaryNavi__icon-label">Search</span>
        </router-link>
      </div> -->
    </div>
    <div>
      <div class="logout">
        <v-button class="secondaryNavi__link --blank" @click.prevent="logout">
          <svg>
            <use xlink:href="#logout"></use>
          </svg>
        </v-button>
      </div>
    </div>
  </nav>
</template>
<script>
import Button from './button';
import authApi from '@/apis/auth-api';

export default {
  components: {
    'v-button': Button
  },
  data() {
    return {

    };
  },
  props: [

  ],
  mounted() {

  },
  computed: {
    username() {
      return this.$store.getters.userName;
    }
  },
  methods: {
    settings() {
      this.$store.commit('overlay_isOpen', true);
      this.$store.commit('overlay_content', 'settings');
    },
    logout() {
      authApi.logout().then(() => {
        this.$router.push('signin');
        localStorage.removeItem('token');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mainNavigationBar.vue